import React from "react";
import Input from "../../../common/Input";
import { LabelWithAsteriskMark } from "../../../common/CommonLabel";

export const PrefixSequenceInputValidator = ({
    id,
    dataTestId,

    title,
    value,
    onChange,
    validation,
    placeholder,

}) => {

    return (
        <div>
            <Input
                id={id}
                dataTestId={dataTestId}
                item={{
                    type: "text",
                    required: true,
                    fullWidth: true,
                    value: value || '',
                    validation: validation,
                    placeholder: placeholder,
                    onBlur: (e) => { onChange(e.target.value) },
                    onChange: (e) => { onChange(e.target.value) },
                    title: <LabelWithAsteriskMark label={title} />,
                }}
            />
        </div>
    )
}
function validatePrefixSequence(input = '') {
    // Default Predefined Prefixes
    const predefinedPrefixes = ['EST-', 'SO-', 'DC-', 'INV-', 'CN-', 'PO-', 'PBL-', 'DN-'];

    const matchedPrefix = predefinedPrefixes.find(prefix => input?.startsWith(prefix));

    if (matchedPrefix) {
        const numberPart = input.slice(matchedPrefix.length);
        if (!/^\d+$/.test(numberPart)) {
            return `Invalid format: After the prefix "${matchedPrefix}", only numbers are allowed.`;
        }
    }
}